import React from "react";
import { motion } from "framer-motion";
import { Waves, Music2, Sun, Heart } from "lucide-react";
import SectionTitle from "./SectionTitle";
import { BIO_IMG } from "../data/content";

const tags = [
  { icon: Music2, label: "House · Dance · Electro" },
  { icon: Sun, label: "Énergie estivale" },
  { icon: Waves, label: "Saxophone live" },
  { icon: Heart, label: "Émotion méditerranéenne" },
];

export const Bio = () => (
  <section id="bio" className="section bg-[#050505] py-28">
    <div className="orb orb-purple" style={{ width: 400, height: 400, top: "10%", right: "-8%" }} />
    <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 lg:grid-cols-2 lg:px-8">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="relative"
      >
        <div className="absolute -inset-3 rounded-3xl bg-gradient-to-tr from-electric/40 to-neon/40 blur-2xl" />
        <img
          data-testid="bio-image"
          src={BIO_IMG}
          alt="Oli.Vero en performance"
          className="relative aspect-[4/5] w-full rounded-3xl object-cover"
        />
      </motion.div>

      <div className="relative z-10">
        <SectionTitle kicker="Biographie" title="Franco-italien, enfant de la Méditerranée" testid="bio-title" />
        <div className="space-y-5 font-body text-base leading-relaxed text-white/75">
          <p>
            Né entre les côtes françaises et la Sicile, <span className="text-white">Oli.Vero</span> façonne un son
            solaire où la house profonde rencontre la dance euphorique et l'electro cinématographique.
            Ses sets, portés par un saxophone live vibrant, transforment chaque nuit en un lever de soleil sur Ibiza.
          </p>
          <p>
            Inspiré par l'écume, les fêtes qui durent jusqu'à l'aube et l'émotion pure des grands festivals,
            il compose une musique faite pour les foules — intime et gigantesque à la fois.
          </p>
          <p className="text-white/60">
            Disponible pour les programmations de festivals, résidences et clubs internationaux.
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-3">
          {tags.map((t) => (
            <div key={t.label} className="glass flex items-center gap-3 rounded-xl px-4 py-3">
              <t.icon size={18} className="text-electric" />
              <span className="font-heading text-sm text-white/80">{t.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Bio;
